<template>
  <div>
    <div class="card">
      <div class="card-body">
        <div class="card-header"><h4>Adicionar Tópico</h4></div>
        <div class="row">
          <div class="col-md-4">
            <label for="nome">Título</label>
            <input
              id="titulo"
              type="text"
              class="form-control"
              placeholder="Digite um titulo:"
              v-model="state.titulo"
            />
          </div>
          <div class="col-md-6">
            <label for="nome">Tópico</label>
            <textarea
              id="topico"
              class="form-control"
              v-model="state.topico"
            ></textarea>
          </div>

          <div class="col-md-2">
            <button @click="salvarTopico()" class="btn-add" type="button">
              Salvar
            </button>
            <button @click="cancelarTopico()" class="btn-c" type="button">
              Cancelar
            </button>
          </div>
        </div>
        <table class="table">
          <thead>
            <tr>
              <th scope="col">Título</th>
              <th scope="col">Ação</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(topico, index) in state.array_topico" :key="topico.id">
              <td>{{ topico.titulo }}</td>
              <td>
                <button
                  @click="alterarTopico(topico.id, topico.titulo, topico.texto)"
                  title="Alterar"
                  type="button"
                  class="btn btn-primary"
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="16"
                    height="16"
                    fill="currentColor"
                    class="bi bi-pencil-fill"
                    viewBox="0 0 16 16"
                  >
                    <path
                      d="M12.854.146a.5.5 0 0 0-.707 0L10.5 1.793 14.207 5.5l1.647-1.646a.5.5 0 0 0 0-.708l-3-3zm.646 6.061L9.793 2.5 3.293 9H3.5a.5.5 0 0 1 .5.5v.5h.5a.5.5 0 0 1 .5.5v.5h.5a.5.5 0 0 1 .5.5v.5h.5a.5.5 0 0 1 .5.5v.207l6.5-6.5zm-7.468 7.468A.5.5 0 0 1 6 13.5V13h-.5a.5.5 0 0 1-.5-.5V12h-.5a.5.5 0 0 1-.5-.5V11h-.5a.5.5 0 0 1-.5-.5V10h-.5a.499.499 0 0 1-.175-.032l-.179.178a.5.5 0 0 0-.11.168l-2 5a.5.5 0 0 0 .65.65l5-2a.5.5 0 0 0 .168-.11l.178-.178z"
                    />
                  </svg>
                </button>
                <button
                  title="Deletar"
                  @click="deleatarTopico(topico.id, index)"
                  type="button"
                  class="btn btn-danger"
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="16"
                    height="16"
                    fill="currentColor"
                    class="bi bi-trash-fill"
                    viewBox="0 0 16 16"
                  >
                    <path
                      d="M2.5 1a1 1 0 0 0-1 1v1a1 1 0 0 0 1 1H3v9a2 2 0 0 0 2 2h6a2 2 0 0 0 2-2V4h.5a1 1 0 0 0 1-1V2a1 1 0 0 0-1-1H10a1 1 0 0 0-1-1H7a1 1 0 0 0-1 1H2.5zm3 4a.5.5 0 0 1 .5.5v7a.5.5 0 0 1-1 0v-7a.5.5 0 0 1 .5-.5zM8 5a.5.5 0 0 1 .5.5v7a.5.5 0 0 1-1 0v-7A.5.5 0 0 1 8 5zm3 .5v7a.5.5 0 0 1-1 0v-7a.5.5 0 0 1 1 0z"
                    />
                  </svg>
                </button>
              </td>
            </tr>
          </tbody>
        </table>
        <div class="btns_right">
          <router-link to="/paginas">
            <button type="button" class="btn_cancel">Voltar</button>
          </router-link>
        </div>
      </div>
    </div>
  </div>
</template>
  <script>
import { onMounted, reactive } from "vue";
import { useRouter } from "vue-router";
import services from "../../services";
import { useStorage } from "vue3-storage";
export default {
  setup() {
    const router = useRouter();
    const storage = useStorage();
    var token = storage.getStorageSync("token");
    const state = reactive({
      //campos para add
      id: "",
      titulo: "",
      topico: "",
      array_topico: [],
      pagina_id: "",
      topico_id: "",
    });
    onMounted(() => {
      if (router.currentRoute._value.params.id != undefined) {
        fetch();
      }
    });
    async function fetch() {
      try {
        const { data } = await services.paginas.getById({
          id: router.currentRoute._value.params.id,
          token,
        });
        state.pagina = data;
        state.array_topico = data.topicos;
        state.topico_id = data.topicos.id;
        console.log(state.topico_id);
      } catch (error) {
        console.log(error);
      }
    }
    async function salvarTopico() {
      if (!state.topico_id || state.topico_id == undefined || state.topico_id == "") {
      /*  var topico = {};
        topico.titulo = state.titulo;
        topico.topico = state.topico;
        state.array_topico.push(topico);*/
        try {
          await services.paginas.saveTopico({
            pagina_id: state.pagina.id,
            texto: state.topico,
            titulo: state.titulo,
            token,
          });
          fetch();
        } catch (error) {
          console.log(error);
        }
      } else {
        try {
          await services.paginas.updateTopico({
            id: state.topico_id,
            texto: state.topico,
            titulo: state.titulo,
            token,
          });
          fetch();
        } catch (error) {
          console.log(error);
        }
      }
    }
    function setEspecialidadeNome(valor) {
      state.especialidade_selecionado_nome = valor;
    }
    async function deleatarTopico(topico_id, plano_i) {
      state.array_topico.splice(plano_i, 1);
      try {
        state.isLoading = true;
        const { data } = await services.paginas.deleteTopicos({
          id: topico_id,
          token,
        });
        console.log(data.status);
        if (data.status != 200) {
          alert("Erro ao deletar tópico.");
        } else {
          alert("Tópico deletado com sucesso.");
        }
      } catch (error) {
        console.log(error);
      }
    }
    async function alterarTopico(topico_id, topico_nome, topico_texto) {
      try {
        state.topico_id = topico_id;
        state.titulo = topico_nome;
        state.topico = topico_texto;
      } catch (error) {
        console.log(error);
      }
    }
    async function cancelarTopico() {
      try {
        state.topico_id = "";
        state.titulo = "";
        state.topico = "";
      } catch (error) {
        console.log(error);
      }
    }

    return {
      router,
      state,
      setEspecialidadeNome,
      salvarTopico,
      deleatarTopico,
      alterarTopico,
      cancelarTopico,
    };
  },
};
</script>
  <style scoped>
h4 {
  color: #000;
}
label {
  color: #000;
  font-size: 12pt;
  margin-bottom: 0;
  margin-top: 5px;
}
input {
  border: solid 1px #000;
}
input:focus {
  border: solid 1px #47b0a9;
}
select {
  border: solid 1px #000;
}
select:focus {
  border: solid 1px #47b0a9;
}
.btns_right {
  text-align: right;
  margin-top: 1rem;
}
.btn_save {
  padding: 5px;
  width: 100px;
  background: #00a000;
  border: solid 2px #000;
  border-radius: 5px;
  transition: 0.2s;
}
.btn_save:hover {
  background: #008000;
}
.btn_cancel {
  padding: 5px;
  width: 100px;
  background: #00a000;
  border: solid 2px #000;
  border-radius: 5px;
  margin-left: 10px;
  transition: 0.2s;
}
.btn_cancel:hover {
  background: #008000;
}
.card {
  border: solid 2px #000;
  border-radius: 10px;
  background-color: #fff;
}
textarea {
  resize: none;
  border: solid 1px #000;
}
textarea:focus {
  border: solid 1px #47b0a9;
}
#pills-home-tab {
  color: #000;
}
#pills-home-tab:focus {
  color: #47b0a9;
}
#pills-profile-tab {
  color: #000000;
}
#pills-profile-tab:focus {
  color: #47b0a9;
}
.btn-add {
  color: #000;
  padding: 5px;
  width: 100px;
  background: orange;
  border: solid 2px #000;
  border-radius: 5px;
  margin-left: 10px;
  margin-top: 25px;
  transition: 0.2s;
}
.btn-add:hover {
  background: rgb(208, 135, 1);
  color: #000;
}
.btn-c {
  color: #000;
  padding: 5px;
  width: 100px;
  background: rgb(255, 0, 0);
  border: solid 2px #000;
  border-radius: 5px;
  margin-left: 10px;
  margin-top: 10px;
  transition: 0.2s;
}
.btn-c:hover {
  background: rgb(181, 0, 0);
  color: #000;
}
tr {
  border-bottom: solid 1px rgb(0, 0, 0);
}
thead {
  color: #000;
  text-align: center;
  background: gray;
}
td {
  color: #000;
  text-align: center;
}
.table {
  margin-top: 2rem;
}
.btn {
  transform: none !important;
  margin-right: 5px;
  margin-bottom: 0;
  padding: 10px;
  width: 40px;
}
</style>